import {
    /** FETCH APPLICATION  */
    FETCH_COMPLETENURSEASSESMENT_FULFILLED,
    FETCH_COMPLETENURSEASSESMENT_REJECTED,
    FETCH_COMPLETENURSEASSESMENT_PENDING,
    RESET_COMPLETENURSEASSESMENT
} from "../../actions/nurse/completeNurseAssesment";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMPLETENURSEASSESMENT_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_COMPLETENURSEASSESMENT_FULFILLED:
            return {
                ...state,
                completeNurseAssesment: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_COMPLETENURSEASSESMENT_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_COMPLETENURSEASSESMENT:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};